import { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import UserContext from '../context/UserContext'
import { Link } from 'react-router-dom'
import logoAnel from '../imgs/logo/minilogo.svg'

import { Main, Botoes, Voltar } from '../styles/GlobalStyled.js'

export default function Home() {
  const { umCm } = useContext(UserContext)

  const [tamAnel, setTamAnel] = useState(150)

  const tamAnelCm = tamAnel / umCm

  const [aro, setAro] = useState(10)

  useEffect(() => {
    if (tamAnelCm <= 1.3) {
      setAro('Seu aro é: ##')
    } else if (tamAnelCm <= 1.55) {
      setAro('Seu aro é: 10/11')
    } else if (tamAnelCm <= 1.63) {
      setAro('Seu aro é: 14')
    } else if (tamAnelCm <= 1.7) {
      setAro('Seu aro é: 16')
    } else if (tamAnelCm <= 1.75) {
      setAro('Seu aro é: 18')
    } else if (tamAnelCm <= 1.85) {
      setAro('Seu aro é: 19/20')
    } else if (tamAnelCm <= 1.95) {
      setAro('Seu aro é: 22/24')
    } else if (tamAnelCm <= 2.0) {
      setAro('Seu aro é: 25/26')
    } else if (tamAnelCm <= 2.1) {
      setAro('Seu aro é: 27/28')
    } else if (tamAnelCm <= 2.2) {
      setAro('Seu aro é: 29/30')
    } else if (tamAnelCm <= 2.3) {
      setAro('Seu aro é: 31/32')
    } else {
      setAro('Seu aro é: ##') // Caso não se encaixe em nenhuma medida
    }
  }, [tamAnelCm])

  return (
    <Main>
      <Container>
        <Instrucoes>
          <h2>Agora é fácil!</h2>
          <h3>
            Coloque o seu anel em cima da figura e ajuste até que{' '}
            <span>a parte verde fique toda dentro do anel</span> e a{' '}
            <p>borda marrom fique escondida por ele.</p>
          </h3>
        </Instrucoes>

        <Cont2>
          <BoxTamanho>
            <CirculoMaior>
              <Circulo tamAnel={`${tamAnel}px`}>
                <img src={logoAnel} alt="The Cosmic"></img>
              </Circulo>
            </CirculoMaior>
          </BoxTamanho>

          <h6>{aro}</h6>
          {/* <h6>{tamAnelCm.toFixed(1)}</h6> */}
        </Cont2>
        <Botoes>
          <input
            type="range"
            name="tamanho"
            min="50"
            max="200"
            step="2"
            value={tamAnel}
            onChange={(e) => setTamAnel(e.target.value)}
          />
          <a
            href="https://www.comcompromisso.com.br"
            target="_blank"
            rel="noreferrer"
          >
            <button>Ir para a loja on-line</button>
          </a>
          <Link to={'/calibragem'}>
            <Voltar>Voltar</Voltar>
          </Link>
        </Botoes>
      </Container>
    </Main>
  )
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vw;
  height: 800px;

  position: relative;

  @media (min-width: 1300px) {
    flex-direction: initial;
    justify-content: center;
    align-items: flex-start;
    height: 90vh;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2,
  h6 {
    font-weight: bold;
    line-height: 50px;
    font-size: 30px;

    @media (min-width: 1300px) {
      font-size: 4vw;
      line-height: 150px;
    }
  }

  h6 {
    font-size: 24px;

    @media (min-width: 1300px) {
      font-size: 2.5vw;
      line-height: 100px;
    }
  }

  h3,
  h4 {
    line-height: 26px;
    font-size: 16px;

    @media (min-width: 1300px) {
      font-size: 2vw;
      line-height: 55px;
    }
  }

  span {
    background-color: #0d9ca9;
    color: #fff;
    font-weight: bold;
  }

  p {
    display: inline;
    background-color: #e1d2c7;
    font-weight: bold;
  }

  h4 {
    margin-top: 10px;
    font-style: italic;
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 5px;
    background: rgba(102, 176, 180, 0.3);
    outline: none;
    width: 80vw;
    height: 10px;
    margin: 10px 20px;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #642c1c;
    cursor: pointer;
  }

  input::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #e1d2c7;
    cursor: pointer;
  }
`

const Instrucoes = styled.div`
  width: 80vw;
  text-align: left;
  margin: 3vh 0;

  @media (min-width: 1300px) {
    margin: 2% 3%;
  }
`

const BoxTamanho = styled.div`
  width: 80vw;
  height: 30vh;
  align-items: left;
  margin-top: 3vh;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
  position: relative;

  @media (min-width: 1300px) {
    margin-top: 20vh;
    width: 35vw;
    margin-right: 5vw;
  }
`

const CirculoMaior = styled.div`
  width: ${(props) => props.tamAnel};
  height: ${(props) => props.tamAnel};
  padding: 5px;
  background-color: #e1d2c7;
  border-radius: 100px;
  position: absolute;
  bottom: 0px;
`

const Circulo = styled.div`
  width: ${(props) => props.tamAnel};
  height: ${(props) => props.tamAnel};
  border-radius: 100px;

  img {
    border-radius: 99px;
  }
`

const Cont2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
